module.exports = __webpack_public_path__ + "img/innisfree1.2ad1947a.jpg";